import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Accordion,
  AccordionSummary,
  Box,
  Dialog,
  List,
  ListItem,
  Paper,
  styled,
} from '@mui/material';

export const DialogStyled = styled(Dialog)(({ theme }) => ({
  zIndex: 1500,

  '& .MuiBackdrop-root': {
    backgroundColor: theme.palette.colors.lockedBackground,
  },
  '& .MuiDialog-paper': {
    margin: 0,
  },
}));

export const PaperStyled = styled(Paper)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  borderRadius: '8px',
  maxWidth: 'none !important',
  backgroundColor: theme.palette.colors.selectedAndDetailBackground,
  padding: '23px 0 0',
  width: '390px',
  [theme.breakpoints.up('md')]: {
    width: '649px',
  },
}));

export const ListStyled = styled(List)(() => ({
  padding: 0,
}));

export const ListItemStyled = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== 'noTopRadius',
})(({ theme, noTopRadius }) => ({
  width: '344px',
  height: '32px',
  backgroundColor: theme.palette.colors.primaryBackground,
  justifyContent: 'space-between',
  padding: '0 8px',
  '&:first-of-type': {
    borderTopLeftRadius: !noTopRadius && '5px',
    borderTopRightRadius: !noTopRadius && '5px',
  },
  '&:last-of-type': {
    borderBottomLeftRadius: '5px',
    borderBottomRightRadius: '5px',
  },
  '&:not(:last-of-type)': {
    marginBottom: '1px',
  },
  [theme.breakpoints.up('md')]: {
    width: '603px',
    padding: '0 22px',
  },
}));

export const AccordionsWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  paddingBottom: '23px',
}));

export const AccordionStyled = styled(Accordion)(({ theme }) => ({
  width: '344px',
  backgroundColor: 'transparent',
  boxShadow: 'none',
  '&::before': {
    display: 'none',
  },
  '&.Mui-expanded': {
    margin: 0,
    '&::before': {
      display: 'none',
    },
  },
  [theme.breakpoints.up('md')]: {
    width: '603px',
  },
}));

export const AccordionSummaryStyled = styled(AccordionSummary)(({ theme }) => ({
  height: '32px',
  minHeight: '32px',
  padding: '0 8px',
  backgroundColor: theme.palette.colors.primaryBackground,
  borderRadius: '5px',

  '&.Mui-expanded': {
    height: '32px',
    minHeight: '32px',
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  '& .MuiAccordionSummary-content': {
    width: '90%',
    margin: 0,
    '&.Mui-expanded': {
      margin: 0,
    },
    [theme.breakpoints.up('md')]: {
      width: '66%',
    },
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    width: '10%',
    display: 'flex',
    justifyContent: 'flex-end',
    '& svg': {
      transform: 'rotate(0deg)',
      transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    },
    '&.Mui-expanded': {
      transform: 'none',
      transition: 'none',

      '& svg': {
        transform: 'rotate(180deg)',
        transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      },
    },
    [theme.breakpoints.up('md')]: {
      width: '33%',
    },
  },
  [theme.breakpoints.up('md')]: {
    padding: '0 22px',
  },
}));

export const AccordionDetailsStyled = styled(AccordionSummary)(() => ({
  padding: 0,
  '& .MuiAccordionSummary-content': {
    margin: '1px 0 0',
  },
}));

export const ArrowIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: '14px',
  color: theme.palette.colors.mainFocused,
}));

export const SummaryItem = styled(Box)(() => ({
  width: '50%',
  '&:last-of-type': {
    display: 'flex',
    justifyContent: 'center',
  },
}));
